import { pipe } from 'ramda';
import { isNotNilOrEmpty } from 'ramda-adjunct';

import { fetchValue } from './util';

export default pipe(fetchValue, isNotNilOrEmpty);
